import React, { useState } from 'react';
import { Truck, CheckCircle, Zap, Activity, Settings, TestTube, Save, AlertCircle, TrendingUp } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
export function LogisticsSettings() {
  const [testingProvider, setTestingProvider] = useState<string | null>(null);
  const providers = [{
    id: 'jne',
    name: 'JNE',
    fullName: 'Jalur Nugraha Ekakurir',
    status: 'connected',
    apiKey: '••••••••••••8a9f',
    margin: 15,
    lastSync: '2 menit lalu',
    totalShipments: 1247,
    avgDeliveryTime: '2.3 hari',
    successRate: 98.5
  }, {
    id: 'jnt',
    name: 'J&T',
    fullName: 'J&T Express',
    status: 'connected',
    apiKey: '••••••••••••4b2c',
    margin: 12,
    lastSync: '5 menit lalu',
    totalShipments: 892,
    avgDeliveryTime: '2.1 hari',
    successRate: 97.8
  }, {
    id: 'sicepat',
    name: 'SiCepat',
    fullName: 'SiCepat Ekspres',
    status: 'not_connected',
    apiKey: '',
    margin: 0,
    lastSync: 'Belum tersambung',
    totalShipments: 0,
    avgDeliveryTime: '-',
    successRate: 0
  }];
  const testConnection = (providerId: string) => {
    setTestingProvider(providerId);
    setTimeout(() => setTestingProvider(null), 2000);
  };
  return <div className="space-y-6" data-id="element-766">
      {/* Header */}
      <div className="flex items-start justify-between" data-id="element-767">
        <div data-id="element-768">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-769">
            Integrasi Logistik
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-770">
            Konfigurasi koneksi API provider logistik
          </p>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-lg" data-id="element-771">
          <Activity className="w-4 h-4 text-green-600 animate-pulse" data-id="element-772" />
          <span className="text-sm font-bold text-green-700" data-id="element-773">
            2 Provider Aktif
          </span>
        </div>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-4 gap-4" data-id="element-774">
        <Card className="p-4 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-775">
          <div className="flex items-center gap-2 mb-2" data-id="element-776">
            <Truck className="w-5 h-5 text-blue-600" data-id="element-777" />
            <p className="text-sm font-medium text-blue-900" data-id="element-778">
              Total Pengiriman
            </p>
          </div>
          <p className="text-3xl font-bold text-blue-900" data-id="element-779">2,139</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-780">Bulan ini</p>
        </Card>

        <Card className="p-4 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-781">
          <div className="flex items-center gap-2 mb-2" data-id="element-782">
            <CheckCircle className="w-5 h-5 text-green-600" data-id="element-783" />
            <p className="text-sm font-medium text-green-900" data-id="element-784">Success Rate</p>
          </div>
          <p className="text-3xl font-bold text-green-900" data-id="element-785">98.2%</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-786">Rata-rata</p>
        </Card>

        <Card className="p-4 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-787">
          <div className="flex items-center gap-2 mb-2" data-id="element-788">
            <Zap className="w-5 h-5 text-violet-600" data-id="element-789" />
            <p className="text-sm font-medium text-violet-900" data-id="element-790">Avg Delivery</p>
          </div>
          <p className="text-3xl font-bold text-violet-900" data-id="element-791">2.2</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-792">Hari</p>
        </Card>

        <Card className="p-4 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-793">
          <div className="flex items-center gap-2 mb-2" data-id="element-794">
            <TrendingUp className="w-5 h-5 text-amber-600" data-id="element-795" />
            <p className="text-sm font-medium text-amber-900" data-id="element-796">Total Margin</p>
          </div>
          <p className="text-3xl font-bold text-amber-900" data-id="element-797">13.5%</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-798">Rata-rata</p>
        </Card>
      </div>

      {/* Provider Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-799">
        {providers.map(provider => <Card key={provider.id} className={`p-6 relative overflow-hidden ${provider.status === 'connected' ? 'border-green-200 bg-gradient-to-br from-white to-green-50/30' : 'border-slate-200 bg-gradient-to-br from-white to-slate-50'}`} data-id="element-800">
            {/* Status Indicator */}
            <div className="absolute top-0 right-0 w-32 h-32 opacity-5" data-id="element-801">
              <Truck className="w-full h-full" data-id="element-802" />
            </div>

            {/* Header */}
            <div className="flex items-start justify-between mb-6 relative z-10" data-id="element-803">
              <div className="flex items-center gap-4" data-id="element-804">
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center shadow-lg ${provider.status === 'connected' ? 'bg-gradient-to-br from-green-500 to-green-600' : 'bg-gradient-to-br from-slate-400 to-slate-500'}`} data-id="element-805">
                  <Truck className="w-7 h-7 text-white" data-id="element-806" />
                </div>
                <div data-id="element-807">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-808">
                    {provider.name}
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-809">{provider.fullName}</p>
                </div>
              </div>

              {provider.status === 'connected' ? <Badge variant="success" className="flex items-center gap-1" data-id="element-810">
                  <CheckCircle className="w-3 h-3" data-id="element-811" />
                  Tersambung
                </Badge> : <Badge variant="neutral" className="flex items-center gap-1" data-id="element-812">
                  <AlertCircle className="w-3 h-3" data-id="element-813" />
                  Belum Aktif
                </Badge>}
            </div>

            {/* Stats (for connected providers) */}
            {provider.status === 'connected' && <div className="grid grid-cols-3 gap-3 mb-6 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-814">
                <div data-id="element-815">
                  <p className="text-xs text-slate-500 mb-1" data-id="element-816">Total Kirim</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-817">
                    {provider.totalShipments.toLocaleString('id-ID')}
                  </p>
                </div>
                <div data-id="element-818">
                  <p className="text-xs text-slate-500 mb-1" data-id="element-819">Avg Delivery</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-820">
                    {provider.avgDeliveryTime}
                  </p>
                </div>
                <div data-id="element-821">
                  <p className="text-xs text-slate-500 mb-1" data-id="element-822">Success Rate</p>
                  <p className="text-lg font-bold text-green-600" data-id="element-823">
                    {provider.successRate}%
                  </p>
                </div>
              </div>}

            {/* Configuration Form */}
            <div className="space-y-4" data-id="element-824">
              <div data-id="element-825">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-826">
                  API Key
                </label>
                <input type="password" value={provider.apiKey} placeholder="Masukkan API key dari provider" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white font-mono text-sm" data-id="element-827" />
              </div>

              <div data-id="element-828">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-829">
                  Margin Logistik (%)
                </label>
                <input type="number" value={provider.margin || ''} placeholder="15" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-830" />
              </div>

              {provider.status === 'connected' && <div className="flex items-center justify-between p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-831">
                  <div className="flex items-center gap-2" data-id="element-832">
                    <Activity className="w-4 h-4 text-blue-600" data-id="element-833" />
                    <span className="text-sm text-blue-900" data-id="element-834">
                      <span className="font-bold" data-id="element-835">Last Sync:</span>{' '}
                      {provider.lastSync}
                    </span>
                  </div>
                </div>}

              {/* Actions */}
              <div className="flex gap-2 pt-2" data-id="element-836">
                <Button variant="outline" size="sm" fullWidth icon={<TestTube className="w-4 h-4" data-id="element-838" />} onClick={() => testConnection(provider.id)} disabled={testingProvider === provider.id} data-id="element-837">
                  {testingProvider === provider.id ? 'Testing...' : 'Test Koneksi'}
                </Button>
                <Button variant="primary" size="sm" fullWidth icon={<Save className="w-4 h-4" data-id="element-840" />} data-id="element-839">
                  Simpan
                </Button>
              </div>
            </div>
          </Card>)}
      </div>

      {/* Rate Calculator */}
      <Card className="p-6 bg-gradient-to-br from-slate-50 to-slate-100 border-slate-200" data-id="element-841">
        <div className="flex items-center gap-3 mb-6" data-id="element-842">
          <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-843">
            <Settings className="w-6 h-6 text-white" data-id="element-844" />
          </div>
          <div data-id="element-845">
            <h3 className="text-lg font-bold text-slate-900" data-id="element-846">
              Kalkulator Tarif Logistik
            </h3>
            <p className="text-sm text-slate-600" data-id="element-847">
              Simulasi biaya pengiriman dengan margin
            </p>
          </div>
        </div>

        <div className="grid grid-cols-4 gap-4" data-id="element-848">
          <div data-id="element-849">
            <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-850">
              Berat (kg)
            </label>
            <input type="number" placeholder="10" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-851" />
          </div>
          <div data-id="element-852">
            <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-853">
              Jarak (km)
            </label>
            <input type="number" placeholder="50" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-854" />
          </div>
          <div data-id="element-855">
            <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-856">
              Tarif Dasar
            </label>
            <input type="number" placeholder="50000" className="w-full px-4 py-2.5 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-857" />
          </div>
          <div data-id="element-858">
            <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-859">
              Tarif Final
            </label>
            <div className="px-4 py-2.5 rounded-lg bg-blue-100 border-2 border-blue-300 font-bold text-blue-900 flex items-center justify-center" data-id="element-860">
              Rp 57.500
            </div>
          </div>
        </div>
      </Card>
    </div>;
}